export const ADD_ALERT = 'ADD ALERT'

export const addAlert = alert => {
    return {
        type: ADD_ALERT,
        payload: alert
    }
}